import React from 'react';
import PropTypes from 'prop-types';

import './header.scss';

function PageHeader({ title, goBack = null }) {
  return (
    <div className="page-header">
      {goBack && (
        <div className="page-header-back" onClick={() => goBack && goBack()}>
          <i className="arrow_left" />
        </div>
      )}
      {title &&
        (['string', 'number'].includes(typeof title) ? (
          <h2>{title}</h2>
        ) : (
          title
        ))}
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  goBack: PropTypes.func,
};

export default PageHeader;
